import { render, staticRenderFns } from "./navigation-tree-media.vue?vue&type=template&id=af15c196&"
import script from "./navigation-tree-media.vue?vue&type=script&lang=js&"
export * from "./navigation-tree-media.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports